export enum FileTypeType {
    Attachment = '1',
    Biometric = '2',
    Portrait = '3',
    PassPort = '4',
    DrivingLicense = '5',
    NationalIdentityCard = '6'
}